import HR from 'UIComponents/elements/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TriggerGroupDivider({
  children
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-row align-center",
    children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx("strong", {
      className: "no-shrink p-x-4",
      children: children
    }), /*#__PURE__*/_jsx(HR, {})]
  });
}